var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#FF6109",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41217 21.3535C5.854 21.3535 5.38203 21.162 4.99624 20.7789C4.61046 20.3959 4.41757 19.9273 4.41757 19.373V5.36324H3.15234V3.38279H8.45999V2.37842H15.5263V3.38279H20.8481V5.36324H19.5829V19.373C19.5829 19.9148 19.3869 20.3803 18.9948 20.7696C18.6028 21.1588 18.1339 21.3535 17.5883 21.3535H6.41217ZM17.5883 5.36324H6.41217V19.373H17.5883V5.36324ZM8.99152 17.3361H10.7317V7.36107H8.99152V17.3361ZM13.2687 17.3361H15.023V7.36107H13.2687V17.3361Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrashIcon);
export default __webpack_public_path__ + "static/media/delete-trash-icon.ff2e2edb3860dda41872c372d325087d.svg";
export { ForwardRef as ReactComponent };